module.exports = __webpack_public_path__ + "static/media/04 Bassoon Region 20 Scales.2d384050.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/middleSchool/scales/04 Bassoon Region 20 Scales.pdf
// module id = 264
// module chunks = 0